import React, { useEffect } from 'react';
import { AppUpdateBanner } from '@/components/shared/AppUpdateBanner';
import { useAppVersionCheck } from '@/hooks/useAppVersionCheck';

export function AppVersionProvider({ children }) {
  const { updateAvailable, latestVersion, runningVersion } = useAppVersionCheck();

  useEffect(() => {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('_appRefresh')) return;
    url.searchParams.delete('_appRefresh');
    window.history.replaceState(null, '', url.toString());
  }, []);

  return (
    <>
      {children}
      <AppUpdateBanner
        updateAvailable={updateAvailable}
        runningVersion={runningVersion}
        latestVersion={latestVersion}
      />
    </>
  );
}
